import { gql } from '@apollo/client';

export default class PayrollGeneralQuery {
    static GET_PAYROLL_EMPLOYEE_LIST = gql`
        query getPayrollEmployeesList($input: PayrollEmployeeListInput!) {
            getPayrollEmployeesList(input: $input) {
                id
                salary
                lotName
                payType
                department
                quickNotes
                loanBalance
                employeeName
                employeeType
                pendingFinalPayment
            }
        }
    `;

    static GET_PAY_PERIODS = gql`
        query getPayPeriods($lotName: String!, $year: Int!) {
            getPayPeriods(lotName: $lotName, year: $year)
        }
    `;

    static GET_DAILY_ACTION_LOG = gql`
        query getDailyActionLog($offset: Int, $limit: Int, $search: String) {
            getDailyActionLog(offset: $offset, limit: $limit, search: $search) {
                timeId
                userId
                userName
                firstName
                lastName
                lineStatus
                timeInUtc
                timeOutUtc
                timeInReason
                timeOutReason
                totalHours
            }
        }
    `;

    static HAS_PENDING_CLOCK_OUT_ACTION = gql`
        query hasPendingClockOutAction {
            hasPendingClockOutAction
        }
    `;

    static EMPLOYEE_HAS_CHECK = gql`
        query employeeHasCheck($employeeId: Int!, $payPeriod: String!) {
            employeeHasCheck(employeeId: $employeeId, payPeriod: $payPeriod)
        }
    `;
}
